import Quasar from 'quasar/src/vue-plugin.js';;
import moment from 'moment';
var myLocale = Quasar.lang.getLocale();
moment.locale(myLocale);